import { UserInterface } from "../../interfaces";



export interface UserState {
  user: UserInterface | null;
}

export const initialUserState: UserState = {
  user: null,
};

type UserAction =
  | { type: "SET_USER"; payload: UserInterface }
  | { type: "CLEAR_USER" };

export function userReducer(state: UserState, action: UserAction): UserState {
  switch (action.type) {
    case "SET_USER":
      return { ...state, user: action.payload };
    case "CLEAR_USER":
      return { ...state, user: null };
    default:
      return state;
  }
}
